import { api } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api';
import type {
  OrganizationSettings,
  UpdateOrganizationSettingsData,
} from '../types';

export const organizationApi = {
  getSettings: async (): Promise<OrganizationSettings> => {
    const response = await api.get<ApiResponse<OrganizationSettings>>(
      '/organization',
    );
    return response.data;
  },

  updateSettings: async (
    data: UpdateOrganizationSettingsData,
  ): Promise<OrganizationSettings> => {
    const response = await api.patch<ApiResponse<OrganizationSettings>>(
      '/organization',
      data,
    );
    return response.data;
  },

  getUploadUrl: async (
    filename: string,
    contentType: string,
  ): Promise<{ signedUrl: string; token: string; path: string }> => {
    const response = await api.post<
      ApiResponse<{
        signedUrl: string;
        token: string;
        path: string;
      }>
    >('/organization/upload-url', { filename, contentType });
    return response.data;
  },
};
